import React from 'react';
import { FAQ } from '../components/FAQ';
import { useScreenInit } from '../useScreenInit';
import { PricingSection } from '../components/PricingSection';
export function Pricing() {
  useScreenInit('Pricing');
  return <div className="min-h-screen bg-[#FAF8F4] pt-16 pb-20" data-id="element-4601">
      <PricingSection data-id="element-4602" />

      <div className="max-w-[1280px] mx-auto px-6 md:px-10" data-id="element-4603">
        {/* FAQ Section */}
        <div className="border-t border-neutral-200 pt-20" data-id="element-4604">
          <div className="text-center mb-12" data-id="element-4605">
            <h2 className="text-3xl md:text-4xl font-title font-bold text-[#2B211A]" data-id="element-4606">
              Frequently Asked Questions
            </h2>
          </div>
          <FAQ data-id="element-4607" />
        </div>
      </div>
    </div>;
}